import { AntennaSignal, ArrowBlSquare, Cloud, DashboardSpeed, DatabaseBackup, Internet, IpAddress, ModernTv4K, NetworkLeft, Phone, Tv, TvFix, View360, ViewGrid, ViewStructureDown, Wifi } from 'iconoir-react';
import React from 'react'

const Iconos = {
  0: {
    Config: [
      { name: "AWS Cloud", id: "001", icon: <Cloud /> },
      { name: "DataCenter", id: "002", icon: <DatabaseBackup /> },
      { name: "Colocation", id: "003", icon: <ArrowBlSquare /> },
      { name: "Hosting", id: "004", icon: <Internet /> },
    ],
    icono: <DatabaseBackup />
  },
  1: {
    Config: [
      { name: "Troncal IP", id: "005", icon: <IpAddress /> },
      { name: "Citofonia", id: "006", icon: <Phone /> },
    ],
    icono: <Phone />
  },
  2: {
    Config: [
      { name: "Streaming/Servicio", id: "007", icon: <ViewStructureDown /> },
      { name: "TV Adaptativa", id: "008", icon: <ModernTv4K/> },
      { name: "TV Empresarial", id: "009", icon: <TvFix /> },
      { name: "Cabecera/Servicio", id: "010", icon: <View360 /> },
      { name: "TV para ISP", id: "011", icon: <ViewGrid /> },
    ],
    icono: <Tv />
  },
  3: {
    Config: [
      { name: "Internet Alta Velocidad", id: "012", icon: <DashboardSpeed /> },
      { name: "Internet Dedicado", id: "013", icon: <AntennaSignal /> },
      { name: "Lan to Lan", id: "014", icon: <NetworkLeft /> },
    ],
    icono: <Wifi />
  },
};
export default Iconos;
